import { Injectable, inject } from '@angular/core';
import { ApiService, Post } from '@franbase/shared/data-access';
import { ComponentStore } from '@ngrx/component-store';
import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { tap } from 'rxjs';


interface SharedPostStoreState extends EntityState<Post> {
  error: string
}
const adapter = createEntityAdapter<Post>();
const initialState: SharedPostStoreState = adapter.getInitialState({
  error: ''
})
const { selectAll } = adapter.getSelectors();

@Injectable({
  providedIn: 'root'
})
export class SharedPostStoreService extends ComponentStore<SharedPostStoreState> {

  apiSV = inject(ApiService);

  constructor() { super(initialState); }

  data$ = this.select(selectAll);
  error$ = this.select((s) => s.error);

  getPostBySlug(slug: string) {
    return this.select(this.data$, (rs) => rs.filter(r => r.slug == slug)[0] as Post).pipe(
      tap(rs => {
        if (!rs) {
          this.apiSV.postDetail('slug', slug).then(rs => {
            if (rs.success) {
              this.setState((state) => adapter.setOne(rs.data, state));
              this.patchState({ error: '' })
            } else {
              this.patchState({ error: rs.message })
            }
          }).catch(err => {
            this.patchState({ error: err.message })
          });
        }
      })
    );
  }
}
